<div class="filters">
  <mat-form-field>
    <mat-select [(value)]="selectedColumn">
      <mat-option value="">Search...</mat-option>
      @for (column of columns; track column.key) {
        @if (column.filterable) {
          <mat-option [value]="column.key">
            {{ column.label }}
          </mat-option>
        }
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <span matIconSuffix class="search-icons">
      @if (searchControl.value) {
        <mat-icon (click)="clearSearch()" style="cursor: pointer">close</mat-icon>
      }
      <mat-icon
        (click)="searchControl.valid && search()"
        [class.disabled]="searchControl.invalid"
        style="cursor: pointer"
        >search</mat-icon
      >
    </span>
    <input
      matInput
      placeholder="Search in the table"
      matTooltip="{{ tooltipText }}"
      [formControl]="searchControl"
      (keydown.enter)="searchControl.valid && search()" />
  </mat-form-field>
  <button mat-icon-button (click)="clearFilters()">
    <span class="material-symbols-outlined">filter_alt_off</span>
  </button>
</div>
